<ag-task (goBackEvent)="goBackEvent.emit($event)" [isUrlMode]="isUrlMode" [selectedFeatureMode]="selectedFeatureMode"
         [sidebarEl]="featureComponentSidebarEl" [urlModeGoBackUrl]="urlModeGoBackUrl" class="full-height-container"
         id="task-component">
  <ng-template agClassifier="{{FeatureComponentMode.EDIT_ROW}}">

    <app-event-type-detail class="task-component-detail full-height-container"></app-event-type-detail>
  </ng-template>
</ag-task>
